module.exports = __webpack_public_path__ + "static/media/aq.3261c2b0.svg";